<template>
	<div class="opts_wrap" v-loading="loading">
		<div class="opts_line">
			<p class="txt" style="display: inline-block;">打印机：</p>
			<div class="con" style="display: inline-block;width: 70%;">
				<el-select v-model="printer" placeholder="请选择" clearable>
					<el-option v-for="item in printers" :key="item.name" :label="item.name" :value="item.name">
					</el-option>
				</el-select>
			</div>
		</div>
		<div class="opts_line">
			<p>已勾选订单数：{{total}}</p>
			<p>打印成功数：{{success_num}}</p>
			<p>打印失败数：{{fail_num}}</p>
			<el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
		</div>

		<div class="btn_wrap">
			<p class="btn" :class="total==0||is_posting?'disabled':''" @click="batPrint()">打印</p>
			<p class="btn" @click="cancel()">取消</p>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		mapActions,
		mapState,
		mapMutations
	} from "vuex";
	export default {
		name: "orderPrinter",
		props: {
			isLoading: {
				type: Boolean,
				default: false
			},
			show: {
				type: Boolean,
				default: false
			},
			ids: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				loading: false,
				arr_ids: [],
				percentage: 0,
				total: 0,
				success_num: 0,
				fail_num: 0,
				is_posting: false,
				printer: '',
				printers: [],
				socket: null,
				print_order_id: ''
			};
		},

		created() {
			this.init()
		},
		mounted() {},

		computed: {
			...mapState({}),
		},
		watch: {
			show(val) {
				if (val) {
					this.arr_ids = this.ids
					this.percentage = 0
					this.init()
				}
			}
		},

		methods: {
			...mapActions({
				getSupplierPrintInfo: "ucenter/getSupplierPrintInfo",
			}),
			init() {
				this.arr_ids = this.ids
				console.log(this.arr_ids)
				this.is_posting = false
				this.total = this.arr_ids.length
				this.success_num = 0
				this.fail_num = 0
				if (this.ids.length == 0) {
					this.$emit('close', {})
					return
				}
				this.doConnect()
			},
			
			//批量打印
			batPrint() {
				if (this.is_posting) return
				this.success_num = 0
				this.fail_num = 0
				this.is_posting = true
				this.addPrint(0)
			},

			addPrint(idx) {
				//一条条记录请求发货
				let param = {
					supplier_order_id: this.arr_ids[idx],
				}
				this.getSupplierPrintInfo({
					data: param,
					success: (res) => {
						console.log(res)
						
						if (res.code == 200) {
							this.success_num++
							this.doPrint(res.data)
						} else {
							this.fail_num++
						}
						var total = this.total
						this.percentage = Number(((idx + 1) / total * 100).toFixed(2))
						if (total - 1 > idx) {
							this.addPrint(idx + 1)
						} else {
							// this.is_posting = false
							this.$message({
								message: '操作完成',
								type: 'success'
							})
							// this.$emit('success', {})
						}
					}
				})
			},

			cancel() {
				this.$emit('close', {})
			},
			//打印相关
			//连接打印客户端
			doConnect() {
				let that = this
				that.socket = new WebSocket('ws://127.0.0.1:13888');
				// 打开Socket
				that.socket.onopen = function(event) {
					that.$message({
						message: '连接成功',
						type: 'success'
					})
					that.doGetPrinters()
				};
				// 监听消息
				that.socket.onmessage = function(event) {
					var data = JSON.parse(event.data)
					if (data.cmd == 'getPrinters') {
						console.log('获取打印机', data);
						that.printers = data.printers
						that.doSetPrinterConfig(data.printers[1].name)
						return;
					}
					if (data.cmd == 'setPrinterConfig') {
						// console.log('设置打印机',data,event)
						return;
					}
					if (data.cmd == 'print') {
						console.log('打印成功',that.print_order_id,data.taskID)
						return;
					}
					if (data.cmd == 'getTaskStatus') {
						console.log('状态', data)
						return
					}

				};
				// 监听Socket的关闭
				that.socket.onclose = function(event) {
					that.$alert('连接失败，请检查抖店打单组件是否启动', '提示', {
						type: 'error',
						confirmButtonText: '确定',
						callback: action => {
							console.log(event)
							that.$emit('close', {})
						}
					});
					that.socket = null
				};
			},

			//获取打印机信息
			doGetPrinters() {
				var request = {
					requestID: this.getNonceStr(),
					version: '1.0',
					cmd: 'getPrinters'
				};
				this.socket.send(JSON.stringify(request));
			},
			//设置打印机
			doSetPrinterConfig(name) {
				var request = {
					requestID: this.getNonceStr(),
					version: "1.0",
					cmd: "setPrinterConfig",
					printer: {
						name: name,
						needTopLogo: true,
						needBottomLogo: false
					}
				};
				this.printer = name
				this.socket.send(JSON.stringify(request));
			},
			//打印
			doPrint(data) {
				console.log(666,data)
				data = data.print_data
				this.print_order_id = data.order_id
				var request = {
					"cmd": "print",
					"requetID": this.getNonceStr(),
					"version": "1.0",
					"task": {
						"taskID": this.getNonceStr(),
						// "taskID": data.documentID,
						"preview": false,
						"printer": this.printer,
						"documents": [{
							"documentID": data.documentID,
							"contents": [{
									"templateURL": data.template_url1,
									"params": data.params_str,
									"signature": data.signature,
									"encryptedData": data.encryptedData,
									"addData": data.addData
								},
								{
									"templateURL": data.template_url,
									"data": data.data,
								}
							]
						}]
					}
				};
				// var request = {
				// 	"cmd": "print",
				// 	"requetID": this.getNonceStr(),
				// 	"version": "1.0",
				// 	"task": {
				// 		"taskID": this.getNonceStr(),
				// 		// "taskID": data.documentID,
				// 		"preview": false,
				// 		"printer": this.printer,
				// 		"documents": [{
				// 			"documentID": data.documentID,
				// 			"contents": [{
				// 				"templateURL": data.template_url,
				// 				"params": data.params_str,
				// 				"signature": data.signature,
				// 				"encryptedData": data.encryptedData,
				// 				"addData": data.addData
				// 			}]
				// 		}]
				// 	}
				// };
				this.socket.send(JSON.stringify(request));
			},
			//生成纯数字随机字符串
			getNonceStr(number = 10) {
				var arr = [];
				var arr1 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
				var nonceStr = ''
				for (var i = 0; i < number; i++) {
					var n = Math.floor(Math.random() * 10);
					arr[i] = arr1[n];
					nonceStr += arr1[n];
				}
				return new Date().getTime() + nonceStr
			},

		},

	}
</script>

<style scoped>
	.opts_wrap {
		padding-top: 14px;
	}

	.opts_wrap .opts_line p {
		margin-bottom: 15px;
	}

	.opts_wrap .btn_wrap {
		margin: 40px auto 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.opts_wrap .btn_wrap .btn {
		width: 80px;
		height: 34px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		box-sizing: border-box;
		font-size: 14px;
	}

	.opts_wrap .btn_wrap .btn:nth-child(1) {
		background: var(--red);
		color: #fff;
		margin-right: 14px;
	}

	.opts_wrap .btn_wrap .btn.disabled {
		background-color: #C0C4CC;
		color: #333;
	}

	.opts_wrap .btn_wrap .btn:nth-child(2) {
		background: #fff;
		color: #333;
		border: 1px solid #ddd;
		margin-right: 14px;
	}

	.ml8 {
		margin-left: 8px;
	}

	.opts_wrap .btn_wrap .btn:nth-child(3) {
		background: #fff;
		color: #333;
		border: 1px solid #ddd;
	}

	.w80 {
		width: 80px;
	}

	.w100 {
		width: 100%;
	}

	.s_line {
		padding: 0 12px;
		height: 34px;
		line-height: 34px;
		border: 1px solid #DCDFE6;
		border-radius: 4px;
		width: 100%;
	}

	.s_line .label {
		color: #C0C4CC;
		font-size: 14px;
		width: 68px;
		display: inline-block;
	}

	.s_line .info {
		display: inline-block;
	}

	.el-input {
		height: 34px;
		line-height: 34px;
	}

	/deep/.el-input__prefix {
		height: 34px;
		line-height: 34px;
		margin-left: 15px;
		left: 0 !important;
	}

	/deep/.el-select .el-input__inner {
		height: 34px;
		line-height: 34px;
	}

	/deep/.el-input--prefix .el-input__inner,
	.el-cascader .el-input .el-input__inner {
		padding-left: 80px;
		height: 34px !important;
	}

	/deep/.el-progress-bar__innerText {
		color: #333 !important;
	}

</style>